import { EmptyInstance } from "core-library/mixins/empty-instance";
import { EventEmitterMixin } from "widgets-module/mixins/event-emitter.mixin";

export class NotificationPaneComponent extends EventEmitterMixin(EmptyInstance) {
    public static readonly SELECTOR = ".js-pcg-notification-pane";
    public static readonly REMOVE_EVENT = "notification-pane/remove";

    private readonly _classMap = {
        closeButtonSelector: ".js-pcg-notification-pane__close-btn"
    };

    private _currentContext: JQuery = null;
    private _closeButton: JQuery = null;
    private _closed: boolean = true;

    private _id: string = null;
    public get id(): string {
        return this._id;
    }

    public show(): void {
        if (this._closed) {
            this._currentContext.css("display", "block");
            this._closed = false;
        }
    }

    public close(): void {
        this._currentContext.css("display", "none");
        this._closed = true;
    }

    public destroy = (): void => this.complete(NotificationPaneComponent.REMOVE_EVENT);

    private bindEvents(): void {
        this._closeButton.on("click", () => {
            this.close();
            this.emit(NotificationPaneComponent.REMOVE_EVENT, this);
        });
    }

    private parseContext(): void {
        this._closeButton = $(this._classMap.closeButtonSelector, this._currentContext);
        this._id = this._currentContext?.data("id") as string;
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
